const hotels = {
  HOTELTERRA: {
    colorPrimary: "!bg-[#0e2d1b]",
    hoverColorPrimary: "bg-[#0e2d1b]",
    colorTextPrimary: "text-[#ff8D6D]",
    colorSecundary: "bg-[#ff8D6D]",
    privacyPolicies: "https://terrabiohotel.com/politica-de-privacidad/",
    dataProtection: "https://terrabiohotel.com/proteccion-de-datos/",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#7bbb4b",
    url: "https://terrabiohotel.com/",
  },
  HOTELKOKKOBEACH: {
    colorPrimary: "!bg-[#0a5b4c]",
    hoverColorPrimary: "bg-[#0a5b4c]",
    colorTextPrimary: "text-[#ff8D6D]",
    colorSecundary: "bg-[#ff8D6D]",
    privacyPolicies: "https://terrabiohotel.com/politica-de-privacidad/",
    dataProtection: "https://terrabiohotel.com/proteccion-de-datos/",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#7bbb4b",
    url: "#",
    sizeLogo: "md:h-28",
  },
  HOTELWAIRA: {
    colorPrimary: "!bg-[#9cc25b]",
    hoverColorPrimary: "bg-[#1ca520]",
    colorTextPrimary: "text-[#244725]",
    colorSecundary: "bg-gray-800",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#1ca520",
    url: "https://frhotel.co/",
    sizeLogo: "md:h-32",
    excludeTaxes: true,
  },

  LACHINCA: {
    colorPrimary: "!bg-[#7d572f]",
    hoverColorPrimary: "bg-[#1ca520]",
    colorTextPrimary: "text-[#fff8dd]",
    colorSecundary: "bg-[#fdbd57]",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-black ",
    linkItemMenu: "text-white",
    colorIcon: "#cb4457",
    url: "#",
    sizeLogo: "md:h-32",
    // excludeTaxes: true,
  },
  ABORIGENESLOCAL: {
    colorPrimary: "!bg-[#7d572f]",
    hoverColorPrimary: "bg-[#1ca520]",
    colorTextPrimary: "text-[#fff8dd]",
    colorSecundary: "bg-[#fdbd57]",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-black ",
    linkItemMenu: "text-white",
    colorIcon: "#cb4457",
    url: "#",
    sizeLogo: "md:h-32",
    // excludeTaxes: true,
  },

  HOTELFR: {
    colorPrimary: "!bg-[#08401B]",
    hoverColorPrimary: "bg-[#1ca520]",
    colorTextPrimary: "text-white",
    colorSecundary: "bg-[#AEBFB4]",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#08401B",
    url: "https://wairahotel.com.co/",
    bookingEngineUrl: "https://hotelfr.hotelesya.com/",
    sizeLogo: "md:h-32",
    // grayScale: true,
  },
  HOTELWAIRALOCAL: {
    colorPrimary: "!bg-[#9cc25b]",
    hoverColorPrimary: "bg-[#1ca520]",
    colorTextPrimary: "text-[#244725]",
    colorSecundary: "bg-gray-800",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#1ca520",
    url: "#",
    sizeLogo: "md:h-32",
    excludeTaxes: true,
  },
  ACRESHOTEL: {
    colorPrimary: "bg-[#181818]",
    hoverColorPrimary: "bg-[#181818]",
    colorTextPrimary: "text-white",
    colorSecundary: "bg-[#a14a25]",
    privacyPolicies: "#",
    dataProtection: "#",
    grayScale: false,
    callToActions: "text-white",
    url: "https://arishahotel.com/",
  },
  ABORIGENES: {
    colorPrimary: "!bg-[#000000]",
    hoverColorPrimary: "bg-[#000000]",
    colorTextPrimary: "text-[#c0622f]",
    colorSecundary: "bg-[#c0622f]",
    privacyPolicies: "",
    dataProtection: "",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#c0622f",
    url: "#",
    bookingEngineUrl: "https://aborigenes.hotelesya.com/",
    sizeLogo: "md:h-24",
  },
  ARISHA: {
    colorPrimary: "bg-[#181818]",
    hoverColorPrimary: "bg-[#181818]",
    colorTextPrimary: "text-white",
    colorSecundary: "bg-[#a14a25]",
    privacyPolicies: "#",
    dataProtection: "#",
    grayScale: true,
    callToActions: "text-white",
    url: "https://arishahotel.com/",
  },
  PIEDRALOCAL: {
    colorPrimary: "!bg-[#0a5b4c]",
    hoverColorPrimary: "bg-[#0a5b4c]",
    colorTextPrimary: "text-[#ff8D6D]",
    colorSecundary: "bg-[#ff8D6D]",
    privacyPolicies: "https://terrabiohotel.com/politica-de-privacidad/",
    dataProtection: "https://terrabiohotel.com/proteccion-de-datos/",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#7bbb4b",
    url: "#",
    sizeLogo: "md:h-32",
    excludeTaxes: true,
  },
  STELLACLUB: {
    colorPrimary: "!bg-[#1f3348]",
    hoverColorPrimary: "bg-[#c0a472]",
    colorTextPrimary: "text-white",
    colorSecundary: "bg-[#c0a472]",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#1ca520",
    url: "#",
    sizeLogo: "md:h-24",
    // grayScale: true,
  },
  HOTELARRECIFE: {
    colorPrimary: "!bg-[#6B5646]",
    hoverColorPrimary: "bg-[#0e2d1b]",
    colorTextPrimary: "text-[#ff8D6D]",
    colorSecundary: "bg-[#D17F56]",
    privacyPolicies: "#",
    dataProtection: "#",
    callToActions: "text-white",
    linkItemMenu: "text-white",
    colorIcon: "#7bbb4b",
    // url: “#”,
  },
  HOTELNIDDO: {
    colorPrimary: "bg-[#3f5a2a]",
    hoverColorPrimary: "bg-[#104B5E]",
    colorTextPrimary: "text-white",
    colorSecundary: "bg-[#EB662A]",
    privacyPolicies: "https://www.niddo.co/terminos-y-condiciones",
    dataProtection: "https://www.niddo.co/terminos-y-condiciones",
    grayScale: false,
    callToActions: "text-white",
    url: "https://www.niddo.co/",
    linkItemMenu: "text-white",
    colorIcon: "#7bbb4b",
    sizeLogo: "md:h-24",
  },
  DEMOTIUMA: {
    colorPrimary: "bg-[#501700]",
    hoverColorPrimary: "bg-[#e7841e]",
    colorTextPrimary: "text-white",
    colorSecundary: "bg-[#e7841e]",
    privacyPolicies: "https://mdf.xib.mybluehost.me/politicas/",
    dataProtection: "https://mdf.xib.mybluehost.me/politicas/",
    grayScale: true,
    callToActions: "text-white",
    url: "https://tiumapark.com/",
    linkItemMenu: "text-white",
  },
};

export default hotels;
